import { X } from 'lucide-react';

/**
 * ImageModal - Reusable modal component for displaying images in full screen
 * 
 * Usage:
 * const [modalImage, setModalImage] = useState({ isOpen: false, src: '', alt: '' });
 * <ImageModal 
 *   isOpen={modalImage.isOpen} 
 *   onClose={() => setModalImage({...modalImage, isOpen: false})} 
 *   imageSrc={modalImage.src} 
 *   imageAlt={modalImage.alt} 
 * />
 */
export const ImageModal = ({ isOpen, onClose, imageSrc, imageAlt }) => {
  if (!isOpen) return null;
  
  return (
    <div 
      className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4 md:p-12"
      onClick={onClose}
      data-testid="image-modal"
    >
      <button 
        onClick={onClose}
        className="absolute top-4 right-4 md:top-6 md:right-6 text-white hover:text-cyan-400 transition-colors bg-gray-900/50 hover:bg-gray-800 rounded-full p-2"
        data-testid="modal-close-btn"
      >
        <X size={28} />
      </button>
      <img 
        src={imageSrc} 
        alt={imageAlt}
        className="max-w-[85vw] max-h-[75vh] rounded-lg shadow-2xl border border-gray-700"
        onClick={(e) => e.stopPropagation()}
      />
    </div>
  );
};

export default ImageModal;
